import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './TournamentListPage.scss'

const TournamentListPage = () => {
	return (
		<div className="main-content tournament-list-page">
			<GamificationBlock
				domId={WIDGETS.tournamentsPage.domId}
				url={WIDGETS.tournamentsPage.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default TournamentListPage
